module.exports = __webpack_public_path__ + "static/media/YouTube.94d2fb81.svg";